// @flow
import React from 'react';

import Connect from '@rover/react-lib/components/utils/Redux/Connect';

import { selectors as creditCardSelectors } from '@rover/react-lib/redux/ducks/creditCards.duck';

import {
  effects as conversationsCheckoutPageEffects,
  selectors as conversationsCheckoutPageSelectors,
} from '../../ConversationsCheckoutPage.duck';

import SelectPaymentMethodForm from './SelectPaymentMethodForm';

const selector = state => ({
  selectedCardId:
    conversationsCheckoutPageSelectors.getSelectedCardId(state) ||
    creditCardSelectors.getDefaultCreditCardId(state),
  errorMessage: conversationsCheckoutPageSelectors.getErrorMessage(state),
});

const effects = {
  onChange: conversationsCheckoutPageEffects.selectCard,
};

export type Props = {
  disabled: boolean,
};

const SelectPaymentMethodFormContainer = (props: Props) => (
  <Connect selector={selector} effects={effects}>
    {connectedProps => <SelectPaymentMethodForm {...props} {...connectedProps} />}
  </Connect>
);

export default SelectPaymentMethodFormContainer;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/components/SelectPaymentMethodForm/SelectPaymentMethodFormContainer.jsx